import LegalShell from "./_LegalShell";

const CookiePolicy = () => (
  <LegalShell
    title="Cookie Policy"
    updated="April 18, 2026"
    description="How HireEva uses cookies and similar technologies — what we set, why, and how to control them in your browser."
  >
    <h2>1. What Are Cookies</h2>
    <p>Cookies are small text files stored on your device when you visit a website. They help the site remember your preferences, keep you logged in, and understand how you use the service.</p>

    <h2>2. Cookies We Use</h2>
    <p><strong>Essential Cookies:</strong> Required for authentication and core functionality. These cannot be disabled.</p>
    <p><strong>Functional Cookies:</strong> Store your preferences such as theme selection.</p>
    <p>We do <strong>not</strong> use advertising or third-party tracking cookies.</p>

    <h2>3. Managing Cookies</h2>
    <p>You can control cookies through your browser settings. Disabling essential cookies may prevent you from using certain features such as the dashboard.</p>

    <h2>4. Changes</h2>
    <p>We may update this policy from time to time. Material changes will be communicated through the site.</p>

    <h2>5. Contact</h2>
    <p>Questions about this policy? Email <a href="mailto:support@electricsheephq.com">support@electricsheephq.com</a>.</p>
  </LegalShell>
);

export default CookiePolicy;